import { Clinic } from '..';

export class UpdateDoctorProfileRequest {
        firstName: string;
        lastName: string;
        address: string;
        keySkills: string;
        qualification: string;
        about: string;
        consultation_fee: number;
        clinics: [{ clinic: Clinic }];
}
